<template>
  <div>
    <v-row no-gutters>
      <v-col
        cols="12"
        md="6"
      >
        <v-img
          :src="trip.image ? trip.image : require('@/assets/images/trip-placeholder.jpg')"
          height="300"
        />

        <trip-header
          v-if="$vuetify.breakpoint.smAndUp"
          :trip="trip"
          :steps="steps"
        />
      </v-col>

      <v-col
        cols="12"
        md="6"
      >
        <trip-header
          v-if="$vuetify.breakpoint.xsOnly"
          :trip="trip"
          :steps="steps"
        />

        <div class="trip-steps__container">
          <v-timeline
            v-if="steps.length"
            dense
          >
            <trip-step-item
              v-for="step in steps.models"
              :key="step.id"
              :step="step"
              @click="canEdit ? openDialog(step) : null"
            />
          </v-timeline>

          <div
            v-else-if="steps.loading || !initialized"
            class="text-center"
          >
            <v-progress-circular
              color="primary"
              indeterminate
            />
          </div>

          <div
            v-else
            class="pa-6"
          >
            <p class="display-1 grey--text text-xs-center font-weight-light">
              Your trip is empty!
            </p>

            <p>
              A trip is composed by many steps that will appear here once
              you create them.
            </p>

            <p>
              Steps are anything that you plan to do on your trip,
              like flights, bus rides, hotel accommodations, events, etc.
            </p>
          </div>

          <div
            v-if="canEdit"
            class="trip-steps__footer pa-4"
          >
            <v-tooltip left>
              <template #activator="{ on }">
                <v-btn
                  fab
                  color="accent"
                  @click="openDialog()"
                  v-on="on"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>

              <span>Add a step</span>
            </v-tooltip>
          </div>
        </div>
      </v-col>

      <trip-step-form
        :trip="trip"
        :edit-model="editStep"
        :show.sync="showEditDialog"
        @save="onStepSave"
      />
    </v-row>
  </div>
</template>

<script>
import TripHeader from '@/components/TripHeader'
import TripMixin from '@/components/TripMixin'
import TripStep from '@/models/TripStep'
import TripStepForm from '@/components/TripStepForm'
import TripStepItem from '@/components/TripStepItem'
import { firestore } from '@/plugins/firebase'

export default {
  name: 'TripOverview',
  components: {
    TripHeader,
    TripStepForm,
    TripStepItem
  },
  mixins: [ TripMixin ],
  data () {
    return {
      editStep: new TripStep(),
      showEditDialog: false
    }
  },
  computed: {
    tripRef () {
      return this.trip.id ? firestore.collection('trips').doc(this.trip.id) : null
    }
  },
  methods: {
    onStepSave () {
      if (this.editStep.country &&
          !this.trip.countries.includes(this.editStep.country)) {
        this.trip.countries.push(this.editStep.country)
        this.trip.save()
      }
    },
    openDialog (step = new TripStep()) {
      this.editStep = step
      this.editStep.tripId = this.tripId
      this.showEditDialog = true
    }
  }
}
</script>

<style lang="scss">
@media (max-width: 600px) {
  .trip-steps__toolbar {
    position: sticky;
    top: 0;
    z-index: 7;
  }
}

@media (min-width: 601px) {
  .trip-steps__container {
    height: calc(100vh - 56px);
    overflow: auto;
  }
}

.trip-steps__footer {
  position: sticky;
  bottom: 16px;
  text-align: right;
  padding: 16px 0;
}
</style>
